import { render } from "./WhiteListView.vue?vue&type=template&id=0b42517a&scoped=true"
import script from "./WhiteListView.vue?vue&type=script&lang=js"
export * from "./WhiteListView.vue?vue&type=script&lang=js"

import "./WhiteListView.vue?vue&type=style&index=0&id=0b42517a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b42517a"]])

export default __exports__